import React, { useState, useEffect, useRef } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Select from '../Elements/Select/Select';
import { resetFilter } from '../../actions/environment';
import { addEvent, removeEvent } from '../../utils/dom';
import { translate, prefix } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './Navigation.scss';

const Navigation = ({ navigation, setup, menuPopupHeight, countryOptions, changeCountry, ...props }) => {
	const [navigationItemExpanded, expandNavigationItem] = useState({
		level0: null,
		level1: null,
		level2: null,
	});
	const navigationContainer = useRef(null);

	useEffect(() => {
		addEvent(document.getElementById('root'), 'click.menuClose', (e) => {
			if (e.target.closest('a') && !navigationContainer.current.contains(e.target) && window.innerWidth < 1100 && navigationItemExpanded.level0 !== null) {
				resetFilterHandler();
			}
		});

		return () => {
			removeEvent(document.getElementById('root'), 'click.menuClose');
		};
	});

	const resetFilterHandler = () => {
		props.resetFilter();
		props.closeSearch();
		props.closeCart();
		expandNavigationItem({
			level0: null,
			level1: null,
			level2: null,
		});
	};

	const expandNavigationHandler = (e) => {
		const id = e.currentTarget.id;
		const level = id.match(/(level\d)/)[1];
		const index = parseInt(id.match(/-(\d+)/)[1], 10);
		props.closeCart();

		if (level === 'level0') e.preventDefault();

		if (level === 'level0' && navigationItemExpanded.level1 !== null) {
			expandNavigationItem((prevState) => ({
				...prevState,
				level1: null,
			}));
		} else if (navigationItemExpanded[level] !== index) {
			e.preventDefault();
			expandNavigationItem((prevState) => ({
				...prevState,
				[level]: index,
			}));
		} else if (level === 'level2' && navigationItemExpanded[level] === index) {
			e.preventDefault();
			expandNavigationItem((prevState) => ({
				...prevState,
				[level]: null,
			}));
		} else {
			props.resetFilter();
			props.closeSearch();
			expandNavigationItem({
				level0: null,
				level1: null,
				level2: null,
			});
		}
	};

	const changeCountryHandler = (id, value) => {
		changeCountry(value);
	};

	return (
		<nav className={s.navigation} ref={navigationContainer}>
			<a id="level0-0" className={[s.mobile, (navigationItemExpanded.level0 !== null ? s.mobile__expanded : null)].join(' ')} href="#open-mobile-menu" aria-label="Open mobile menu" onClick={expandNavigationHandler}>
				<span /><span /><span />
			</a>
			<ul className={s.level1} style={{ height: menuPopupHeight }}>
				{
					navigation.headerNew && navigation.headerNew.map((level1, i) => {
						const level1URI = translate(setup, level1, 'uri');
						const combinedURILevel1 = prefix(setup, level1URI);
						const level2SubCategoryLinks = [];

						if (level1.subPages) {
							level1.subPages.forEach((level2, j) => {
								const level2URI = translate(setup, level2, 'uri');
								const combinedURILevel2 = prefix(setup, level2URI);
								const level2Click = {
									onClick: level2.subPages ? expandNavigationHandler : resetFilterHandler,
								};

								if (level2.title && level2.title.indexOf('<<<') !== -1) {
									level2SubCategoryLinks.push((
										<div key={urlify(level2.title)} className={s.level2_block}>
											<div className={s.level2_block_item}>
												<span className={s.level2_block_item_link} />
											</div>
										</div>
									));
								} else {
									level2SubCategoryLinks.push((
										<div key={urlify(combinedURILevel2)} className={[s.level2_block, (navigationItemExpanded.level2 === j ? s.level2_block__expanded : null)].join(' ')}>
											<div className={s.level2_block_item}>
												<Link id={`level2-${j}`} {...level2Click} className={s.level2_block_item_link} to={combinedURILevel2}>
													<span>{translate(setup, level2, 'title')}</span>
													{ level2.subPages && <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 6L6 1L11 6" stroke="black" strokeWidth="0.3" /></svg> }
												</Link>
											</div>
											{
												level2.subPages && (
													<div className={s.level3}>
														{
															level2.subPages.map((level3, i) => {
																const level3URI = translate(setup, level3, 'uri');
																const styles3 = level3?.styles || {};

																return (
																	<div className={[s.level3_block].join(' ')} key={urlify(level3URI)}>
																		<div className={s.level3_block_item}>
																			<Link className={s.level3_block_item_link} id={`level3-${i}`} to={prefix(setup, level3URI)} style={styles3} onClick={resetFilterHandler}>
																				<span>{translate(setup, level3, 'title')}</span>
																			</Link>
																		</div>
																	</div>
																);
															})
														}
													</div>
												)
											}
										</div>
									));
								}
							});
						}

						const level1Click = {
							onClick: level1.subPages ? expandNavigationHandler : resetFilterHandler,
						};

						return (
							<li key={urlify(combinedURILevel1)} className={[s.level1_column, (navigationItemExpanded.level1 === i ? s.level1_column__expanded : null)].join(' ')}>
								<Link id={`level1-${i}`} className={s.level1_column_link} to={combinedURILevel1} {...level1Click}>
									<span>{translate(setup, level1, 'title')}</span>
								</Link>
								{
									level1.subPages && (
										<div className={s.level1_columnInner}>
											<div className={s.level2}>
												<div className={s.level2_wrapper} style={{ height: `${menuPopupHeight}px` }}>
													{ level2SubCategoryLinks }
													{
														navigation?.headerBottom && i === 0 && (
															<div className={s.level2_wrapper_bottom}>
																{
																	navigation.headerBottom.map((link) => {
																		const level2URI = translate(setup, link, 'uri');
																		if (level2URI === '#') {
																			return (
																				<div key={urlify(combinedURILevel2)} className={[s.level2_block, s.level2_block__country].join(' ')}>
																					<div className={s.level2_block_item}>
																						<Select id="country" variantClasses={['select__navigation', 'label__navigation']} label={translate(setup, link, 'title')} inputChange={changeCountryHandler} selected={setup.country} options={countryOptions} navigation />
																					</div>
																				</div>
																			);
																		}
																		const combinedURILevel2 = prefix(setup, level2URI);
																		return (
																			<div key={urlify(combinedURILevel2)} className={s.level2_block}>
																				<div className={s.level2_block_item}>
																					<Link onClick={resetFilterHandler} className={s.level2_block_item_link} to={combinedURILevel2}><span>{translate(setup, link, 'title')}</span></Link>
																				</div>
																			</div>
																		);
																	})
																}
															</div>
														)
													}
												</div>
											</div>
										</div>
									)
								}
							</li>
						);
					})
				}
			</ul>
			<button className={s.navigation_screen} type="button" aria-label="Close Navigation" onClick={resetFilterHandler} />
		</nav>
	);
};

const mapState = (state, props) => ({ ...props });

export default hot(module)(connect(mapState, { resetFilter })(Navigation));
